import React, { useState } from "react";
import { db } from "../services/firebase.js";
import { Fade } from "react-awesome-reveal";
import { motion } from "framer-motion";
import { Slide, Zoom } from 'react-awesome-reveal';
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { Helmet } from "react-helmet-async";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "../Styles/contact.css";

export default function ContactUs() {
  const text = "Have questions or ideas? Reach out to Paramount Green Services today and let’s start the conversation.".split("");
  const text1 = "Ready to Start Saving Energy?".split("");
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await addDoc(collection(db, "ContactMessages"), {
        ...formData,
        view: false,
        createdAt: serverTimestamp(),
      });

      alert("✅ Message sent successfully!");
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      });
    } catch (err) {
      console.error("Error saving message:", err);
      alert("❌ Failed to send message.");
    }

    setLoading(false);
  };

  return (
    <>
      <Helmet>
        <title>Contact Us || Paramount Green Services</title>
        <meta
          name="description"
          content="Madani Marriage is dedicated to providing a trusted Madani Marriage platform..."
        />
      </Helmet>

      {/* Heading Section */}
      <div className="contact-section py-5" style={{ marginTop: "70px" }}>
        <div className="text-center mb-5">
          <h1 className="contact-title">Contact <span>Us</span></h1>
          <p className="contact-subtitle">
            {text.map((char, index) => (
              <motion.span
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.01 }}
              >
                {char}
              </motion.span>
            ))}
          </p>
        </div>

        {/* 2-Column Layout */}
        <div className="container">
          <Zoom>
            <div className="row g-5">
            {/* Left Column - Info */}
            <div className="col-md-6">
              <button className="mb-3 GIN">Get In Touch</button>
              <h2 className="fw-bold">{text1.map((char, index) => (
                            <motion.span
                              key={index}
                              initial={{ opacity: 0, y: 20 }}
                              animate={{ opacity: 1, y: 0 }}
                              transition={{ delay: index * 0.025, type: "spring", stiffness: 500, damping: 30 }}
                            >
                              {char}
                            </motion.span>
                          ))}</h2>

              <div className="info-box p-3 mb-3 shadow-sm">
                <h6>📞 Call Us Now</h6>
                <p className="mb-0">(+92)320-1171631</p>  <p className="mb-0">(+92)306-8629918</p>
                <small className="text-muted">Free consultation available</small>
              </div>

              <div className="info-box p-3 mb-3 shadow-sm">
                <h6>📧 Email Us</h6>
                <p className="mb-0 text-success">Akash.Paragreen56@gmail.com</p>
                <small className="text-muted">Quick response guaranteed</small>
              </div>

              <div className="info-box p-3 mb-3 shadow-sm">
                <h6>📍 Service Areas</h6>
                <p className="mb-0 text-danger fw-bold">Paramount Green Servcies, PK</p>
                <small className="text-muted">Nationwide coverage available</small>
              </div>

              <div className="info-box p-3 mb-3 shadow-sm">
                <h6>🕒 Operating Hours</h6>
                <p className="mb-0">Monday - Friday: 8:00 AM - 6:00 PM</p>
                <p className="mb-0">Saturday: 9:00 AM - 4:00 PM</p>
                <p className="mb-0">Sunday: <span className="text-danger">Emergency Only</span></p>
              </div>
            </div>

            {/* Right Column - Form */}
            <div className="col-md-6">
              <div className="card shadow-sm border-0 p-5">
                <h5 className="mb-4 fw-bold">Free Eligibility Assessment</h5>
                <p className="text-muted">Get started with your energy efficiency journey today</p>

                <form onSubmit={handleSubmit}>
                  <div className="row gx-3 mb-3">
                    <div className="col-md-6">
                      <input
                        type="text"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                        className="form-control form-control-lg"
                        placeholder="First Name"
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <input
                        type="text"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                        className="form-control form-control-lg"
                        placeholder="Last Name"
                        required
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="form-control form-control-lg"
                      placeholder="Email Address"
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="form-control form-control-lg"
                      placeholder="Phone Number"
                    />
                  </div>

                  <div className="mb-3">
                    <input
                      type="text"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      className="form-control form-control-lg"
                      placeholder="Subject"
                      required
                    />
                  </div>

                  <div className="mb-4">
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      className="form-control form-control-lg"
                      rows="4"
                      placeholder="Tell us about your property, heating system..."
                      required
                    />
                  </div>

                  <button
                    type="submit"
                    className="btn send-btn btn-lg w-100"
                    disabled={loading}
                  >
                    {loading ? "Sending..." : "Submit Assessment Request"}
                  </button>

                  <div className="d-flex justify-content-between mt-3 text-muted small">
                    <span>✅ No obligation</span>
                    <span>🆓 Free assessment</span>
                    <span>⚡ Quick response</span>
                  </div>
                </form>
              </div>
            </div>
          </div>
          </Zoom>

          {/* Google Map */}
          <div className="container my-5">
            <h2 className="text-center mb-4">Find Us</h2>
            <div className="map-container rounded-4 shadow-sm">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4817.437616116378!2d74.1776609373793!3d31.374351708151888!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3918ff002f7e8b35%3A0x7b0fa51a0bddece5!2sParamount%20Green%20Services!5e0!3m2!1sen!2s!4v1758028083151!5m2!1sen!2s"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="map-iframe"
                title="Location Map"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
